"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subaccount = exports.Sequence = exports.Profile = exports.Pricing = exports.Position = exports.Perpspool = exports.Order = exports.Oracle = exports.Misc = exports.Marketstats = exports.Market = exports.Liquiditypool = exports.Liquidation = exports.Leverage = exports.Insurance = exports.Inflation = exports.Fee = exports.Evmmerge = exports.Evmcontract = exports.Evmbank = exports.Erc20 = exports.Coin = exports.Cdp = exports.Broker = exports.Bridge = exports.Book = exports.Bank = exports.Alliance = exports.Admin = void 0;
exports.Admin = __importStar(require("./Switcheo/carbon/admin/export"));
exports.Alliance = __importStar(require("./alliance/alliance/export"));
exports.Bank = __importStar(require("./Switcheo/carbon/bank/export"));
exports.Book = __importStar(require("./Switcheo/carbon/book/export"));
exports.Bridge = __importStar(require("./Switcheo/carbon/bridge/export"));
exports.Broker = __importStar(require("./Switcheo/carbon/broker/export"));
exports.Cdp = __importStar(require("./Switcheo/carbon/cdp/export"));
exports.Coin = __importStar(require("./Switcheo/carbon/coin/export"));
exports.Erc20 = __importStar(require("./Switcheo/carbon/erc20/export"));
exports.Evmbank = __importStar(require("./Switcheo/carbon/evmbank/export"));
exports.Evmcontract = __importStar(require("./Switcheo/carbon/evmcontract/export"));
exports.Evmmerge = __importStar(require("./Switcheo/carbon/evmmerge/export"));
exports.Fee = __importStar(require("./Switcheo/carbon/fee/export"));
exports.Inflation = __importStar(require("./Switcheo/carbon/inflation/export"));
exports.Insurance = __importStar(require("./Switcheo/carbon/insurance/export"));
exports.Leverage = __importStar(require("./Switcheo/carbon/leverage/export"));
exports.Liquidation = __importStar(require("./Switcheo/carbon/liquidation/export"));
exports.Liquiditypool = __importStar(require("./Switcheo/carbon/liquiditypool/export"));
exports.Market = __importStar(require("./Switcheo/carbon/market/export"));
exports.Marketstats = __importStar(require("./Switcheo/carbon/marketstats/export"));
exports.Misc = __importStar(require("./Switcheo/carbon/misc/export"));
exports.Oracle = __importStar(require("./Switcheo/carbon/oracle/export"));
exports.Order = __importStar(require("./Switcheo/carbon/order/export"));
exports.Perpspool = __importStar(require("./Switcheo/carbon/perpspool/export"));
exports.Position = __importStar(require("./Switcheo/carbon/position/export"));
exports.Pricing = __importStar(require("./Switcheo/carbon/pricing/export"));
exports.Profile = __importStar(require("./Switcheo/carbon/profile/export"));
exports.Sequence = __importStar(require("./Switcheo/carbon/sequence/export"));
exports.Subaccount = __importStar(require("./Switcheo/carbon/subaccount/export"));
